import { PendingItemDto } from '@act/shared/data-transfer-objects';
import { memo } from 'react';
import ScheduledEventCard from './feed-card/feed-scheduled-event-card';
import WorkflowCard from './feed-card/workflow-card';
import SurveyCard from './feed-card/survey-card';

export interface SinglePendingItemProps {
  item: PendingItemDto;
}

const SinglePendingItemComponent = ({ item }: SinglePendingItemProps) => {
  switch (item.externalItemType) {
    case 'scheduled_event':
      return <ScheduledEventCard scheduledEventId={item.externalItemId} />;
    case 'workflow_phase':
      return (
        <WorkflowCard
          assignedWorkflowPhaseId={item.externalItemId}
          gettingStarted={false}
        />
      );
    case 'assigned_survey':
      return (
        <SurveyCard
          assignedSurveyId={item.externalItemId}
          shouldHighlight={false}
        />
      );
  }
};

// Memoize to prevent re-renders when props haven't changed
const SinglePendingItem = memo(SinglePendingItemComponent);

export default SinglePendingItem;
